var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ckeditor-custom"},[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Mô tả ")]),_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.entry.description),callback:function ($$v) {_vm.$set(_vm.entry, "description", $$v)},expression:"entry.description"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }